var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#444FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 13.5L9 2.8125L15.1875 13.5H2.8125ZM6.678 8.05725C7.40081 7.57463 8.17594 7.33106 9 7.33106C9.82406 7.33106 10.5992 7.57463 11.322 8.05725L9 4.04662L6.678 8.05725ZM5.58056 9.95288L3.89475 12.8649H14.1053L12.4194 9.95344C11.4013 11.0722 10.2578 11.6404 9 11.6404C7.74225 11.6404 6.59869 11.0723 5.58056 9.95288ZM9 11.0053C10.0901 11.0053 11.0874 10.5047 12.0026 9.48656C11.0874 8.46675 10.0901 7.96669 9 7.96669C7.90987 7.96669 6.91256 8.46731 5.99737 9.486C6.91256 10.5052 7.90987 11.0053 9 11.0053ZM9 10.7336C8.3475 10.7336 7.81819 10.1852 7.81819 9.5085C7.81819 8.83237 8.34694 8.28394 9 8.28394C9.65306 8.28394 10.1818 8.83237 10.1818 9.5085C10.1818 10.1852 9.65306 10.7336 9 10.7336ZM9 10.098C9.31444 10.098 9.56925 9.83419 9.56925 9.5085C9.56925 9.18281 9.31444 8.919 9 8.919C8.68556 8.919 8.43075 9.18337 8.43075 9.5085C8.43075 9.83475 8.68556 10.098 9 10.098Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoa);
export default __webpack_public_path__ + "static/media/poa.578804acefc009cf04d3b3a663ea79d9.svg";
export { ForwardRef as ReactComponent };